import React from "react";
import { Table, Dropdown, OverlayTrigger, Tooltip, Image } from 'react-bootstrap';
import BorderEditIcon from '../../../assets/images/Action-Icons/Border-Edit-Icon.svg';
import ReloadIcon from '../../../assets/images/Action-Icons/Reload-Icon.svg';
import DeleteIcon from '../../../assets/images/Icons/delete-icon.svg';
import CompletedIcon from '../../../assets/images/Icons/aproved-icon.svg';
import HistoryIcon from '../../../assets/images/Action-Icons/history-icon.svg';
import { convertToBaseFormatDate, currencifyInDollars } from "../../../commonservices/CommonMethods";
import TagsHistoryPopup from "../common/components/Modalpopups/SharedTagModal/TagsHistoryPopup";
import { useState } from "react";
import SharedChips from "../common/components/Chips/SharedChips";
import { useDispatch, useSelector } from "react-redux";
import Loader from '../../Shared/Loader/Loader.js';
import callAPI from '../../../commonservices/APIRequests';
import { setAssetTagsInfoData, setDealerTagsInfoData } from "../../../store/Reducers/Tags.js";


const TagsInfo = ({ tagsData, handleTagStatus, tagtype, isEdit = false,vehiclePage =false, onlyViewAccess}) => {

    const dispatch = useDispatch();
    const [showChipLoader, setShowChipLoader] = useState(false);
    const [chipData, setChipData] = useState([]);
    const [openChipId, setOpenChipId] = useState('');
    const { assetTagsInfoData, dealerTagsInfoData } = useSelector((store) => store.sharedTagsReducer)
    const [tagHistoryPopupState, settagHistoryPopupState] = useState({
        showModalPopup: false,
        showLoader: false,
        data: [],
        tagName: ""
    });
    const userDetails = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
    const partnerDetails = localStorage.getItem('partnerDetails') ? JSON.parse(localStorage.getItem('partnerDetails')) : {};
    const handleTagHistory = (data) => {
        settagHistoryPopupState({
            ...tagHistoryPopupState,
            showModalPopup: true,
            data: data?.actionHistory,
            tagName: data?.assetTagName ?? data?.tagName ?? ""
        })
    }
    const { dealerTagsFieldsdata, assetTagsFieldsdata } = useSelector((state) => state.sharedReducer);


    const findTagTableData =(array,chipId, tagtype)=>{
        let itemFound = false
        array?.forEach((item, index) => {
            const findTag = item.find((data) => data._id === chipId)
            if (findTag) {
                itemFound = true
                setChipData(array[index])
            }
        })


        if (!itemFound) {
            handleTagsChipData(chipId, tagtype)
        }
        setOpenChipId(chipId);
    }

    const handleOnclickChips = (isChipOpen, chipId, tagtype) => {
        if (isChipOpen) {
            setOpenChipId('');
        }
        else {
            if(tagtype === 'asset'){
                findTagTableData(assetTagsInfoData,chipId, tagtype)
            }
            else{
                findTagTableData(dealerTagsInfoData,chipId, tagtype)
            }
        }
    }
    


    const handleTagsChipData = (id, tagtype) => {
        setShowChipLoader(true);

        const req = tagtype === 'asset' ? { assetTagId: id } : { tagId: id };

        const apiEndpoint = tagtype === "asset"
            ? '/vehicle/api/v1/lender/getAssetTags'
            : '/lender/api/v1/lender/getDealerTag';

                    return callAPI.get(apiEndpoint, req)
            .then((response) => {
                if (response.status === 200) {


                    if (tagtype === "asset") {
                        dispatch(setAssetTagsInfoData(response.data.assetTags))
                    }
                    else {
                        dispatch(setDealerTagsInfoData(response.data.dealerTags))
                    }


                    setChipData(response.data.assetTags || response.data.dealerTags);
                    setShowChipLoader(false);
                } else {
                    setChipData([]);
                    setShowChipLoader(false);
                }
            });
    };

    const onHandleTagStatus =(data,tagStatus='')=>{
        if(vehiclePage){
            setOpenChipId('');
        }
        handleTagStatus(data,tagStatus)
    }
    

    const getTagRecords = (tagData) => {
        let tag, status, isTagCompleted, completedDateByTag, createdByName, createdAt, tagActionCompletedByName, tagActionReopenedByName, reopenedAt, completedAt

        if (tagtype === "asset") {
            tag = tagData?.assetTagName;
            status = tagData?.assetTagStatus;
        }
        else {
            tag = tagData?.tagName;
            status = tagData?.tagStatus;

        }
        createdAt = tagData?.createdAt
        isTagCompleted = status && status.toLowerCase() === "completed";
        completedDateByTag = tagData?.tagInfo?.completedDate;
        tagActionCompletedByName = tagData?.actionPerformedByName;
        completedAt = tagData?.actionPerformedAt;
        tagActionReopenedByName = tagData?.actionPerformedByName;
        reopenedAt = tagData?.actionPerformedAt;
        createdByName = tagData?.createdByName;

        const datafields = tagtype?.toLowerCase() === "asset" ? assetTagsFieldsdata : dealerTagsFieldsdata
        const findTagData = datafields?.find((data) => data.value === tag);

        if (findTagData) {
            const dynamicFieldsData = findTagData?.tagInputFields
            const completedDynamicsData = isTagCompleted ? findTagData?.tagCompleteFields : []
            return (
                <tbody>
                    {
                        dynamicFieldsData?.reduce((accumulator, { label, value, type, options }, outerIndex) => {
                            // Render the main row for dynamicFieldsData
                            accumulator.push(
                                <tr key={`outer-${outerIndex}`}>
                                    <td className="bold-500">{label}</td>
                                    <td className="tooltip-notes-cell">
                                        {tagData?.tagInfo && tagData.tagInfo[value] ?(
                                            type.toLowerCase().includes("date") ?
                                                convertToBaseFormatDate(tagData.tagInfo[value], true, false) :
                                                type.toLowerCase().includes("amount") ?
                                                    currencifyInDollars(tagData.tagInfo[value]) :
                                                    <div className="tooltip-notes-wrap">
                                                        {typeof tagData.tagInfo[value]==="boolean"?
                                                            ("Yes") :
                                                               tagData.tagInfo[value]
                                                        }
                                                    </div>
                                        ):(
                                            <div className="tooltip-notes-wrap">
                                            {typeof tagData?.tagInfo?.[value] === "boolean" ?
                                                        ("No") :
                                                        "-NA-"
                                                    }
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            );

                            // Render nested rows for Radio Buttons type
                            if (type === "Radio Buttons" && Array.isArray(options)) {
                                options.forEach((option, innerIndex) => {
                                    if (option.hasOwnProperty('fields') && Array.isArray(option.fields) && option.fields.length > 0) {
                                        option.fields.forEach(field => {
                                            if (field.value !== undefined && tagData?.tagInfo && tagData.tagInfo[field.value]) {
                                                accumulator.push(
                                                    <tr key={`inner-${outerIndex}-${innerIndex}`}>
                                                        <td className="bold-500">{field.label}</td>
                                                        <td className="tooltip-notes-cell">
                                                            {field?.type?.toLowerCase().includes("date") ?
                                                                convertToBaseFormatDate(tagData.tagInfo[field.value], true, false) :
                                                                field?.type?.toLowerCase().includes("amount") ?
                                                                    currencifyInDollars(tagData.tagInfo[field.value]) :
                                                                    <div className="tooltip-notes-wrap">
                                                                        {typeof tagData.tagInfo?.[field.value] === "boolean" ?
                                                                            (tagData.tagInfo?.[field.value] ? "Yes" : "No") :
                                                                            tagData.tagInfo[field.value]}
                                                                    </div>
                                                            }
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        });
                                    }
                                });
                            }

                            return accumulator;
                        }, [])
                    }

                    {
                        createdByName ?
                            <tr>
                                <td className="bold-500">Created By</td>
                                <td>{`${createdByName ?? ''} on ${createdAt ? convertToBaseFormatDate(createdAt, true, false) : ''}`}</td>
                            </tr> : null
                    }
                    {
                        isTagCompleted && completedDynamicsData && completedDynamicsData.length > 0 ?
                            <React.Fragment>
                                {
                                    completedDynamicsData?.map(({ label, value,type}, index) => {
                                        if (label && !label.toLowerCase().includes("completed date")) {
                                            return (
                                                <tr key={index}>
                                                    <td className="bold-500">{label}</td>
                                                    <td className="tooltip-notes-cell">
                                                        {tagData?.tagInfo && tagData.tagInfo[value] ? (
                                                            type?.toLowerCase().includes("date") ?
                                                                convertToBaseFormatDate(tagData.tagInfo[value], true, false) :
                                                                type?.toLowerCase().includes("amount") ?
                                                                    currencifyInDollars(tagData.tagInfo[value]) :
                                                                    <div className="tooltip-notes-wrap">{typeof tagData.tagInfo?.[value] === "boolean" ? (tagData.tagInfo?.[value] ? "Yes" : "No") : (tagData.tagInfo[value])}</div>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    })
                                }
                                {
                                    isTagCompleted && completedDateByTag ?
                                        <tr>
                                            <td className="bold-500">{tag} Completed</td>
                                            <td>{completedDateByTag ? convertToBaseFormatDate(completedDateByTag, true, false) : ''}</td>
                                        </tr> : null
                                }
                                {
                                    isTagCompleted && tagActionCompletedByName ?
                                        <tr>
                                            <td className="bold-500">Completed By</td>
                                            <td>{`${tagActionCompletedByName ?? ''} on ${completedAt ? convertToBaseFormatDate(completedAt, true, false) : ''}`}</td>
                                        </tr> : null
                                }
                            </React.Fragment> : null
                    }
                    {
                        tagData && status && status.toLowerCase() === "reopened" && tagActionReopenedByName ?
                            <tr>
                                <td className="bold-500">Reopened By</td>
                                <td>{`${tagActionReopenedByName ?? ''} on ${reopenedAt ? convertToBaseFormatDate(reopenedAt, true, false) : ''}`}</td>
                            </tr> : null
                    }
                </tbody>
            )
        }
    }
    
    return (
        (tagsData?.length > 0) && ((tagtype?.toLowerCase() === "asset" && partnerDetails?.enableAssetTags) || (tagtype?.toLowerCase() === "dealer" && partnerDetails && partnerDetails?.dealerActions?.length && partnerDetails.dealerActions.includes("Create Dealer Tag"))) ?
            <>
                {
                    tagsData.map(obj => {
                        const tag = tagtype === "asset" ? obj?.assetTagName : obj?.tagName;
                        const status = tagtype === "asset" ? obj?.assetTagStatus : obj?.tagStatus;
                        const isCompleted = status && status.toLowerCase() === "completed";
                        const chipId = obj._id;
                        const isChipOpen = openChipId === chipId;

                        return tag ? (
                            <Dropdown className='task-history-table-dropdown asset-tag-item data-tooltip'>
                                <Dropdown.Toggle
                                            variant="success" id="dropdown-basic" style={{ lineHeight: 'initial' }} >
                                    
                                    <small className="dropdown" 
                                    onClick = {() =>  handleOnclickChips(isChipOpen, chipId, tagtype)} >
                                        <SharedChips
                                            type={tagtype?.toLowerCase() === "asset" ? 'assetTag' : 'dealerTag'}
                                            label={(obj && tag) ? tag : ''}
                                            color={`${tag && status && isCompleted ? 'green' : 'brown'}`}
                                        />
                                    </small>
                                </Dropdown.Toggle>
                                {!chipData.length || !chipData ? 
                                <Dropdown.Menu popperConfig={{ strategy: "fixed" }}>
                                    <Dropdown.Item>
                                        <div className="position-relative tags-dropdown-loading">
                                            <Loader show={showChipLoader} styleType='absolute' /> 
                                        
                                        <Table hover responsive className="default-table table table-hover">
                                            <thead className='table-header-bg-color'>
                                                <tr>
                                                    <th className="align-middle">TAG</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr><td class="bold-500">-NA-</td><td class="tooltip-notes-cell">-NA-</td></tr>
                                                <tr><td class="bold-500">-NA-</td><td class="tooltip-notes-cell"><div class="tooltip-notes-wrap">-NA-</div></td></tr>
                                                <tr><td class="bold-500">-NA-</td><td>-NA-</td></tr>
                                            </tbody>
                                        </Table>
                                        </div>
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                                    :
                              <Dropdown.Menu popperConfig={{ strategy: "fixed" }}>
                                    <Loader show={showChipLoader} styleType='absolute' /> 
                                    {chipData && chipData.length > 0 ? chipData.map(data => {
                                    const actionsEnabled = data?.isActionable;
                                    return <Dropdown.Item>
                                        <Table hover responsive className="default-table table table-hover">
                                            <thead className='table-header-bg-color'>
                                                <tr>
                                                    <th colSpan={isEdit ? 1 : 2}>
                                                        {tag}
                                                    </th>
                                                    {isEdit && !userDetails.readOnlyAccess && !onlyViewAccess ? <th className="align-middle">
                                                        <div className='d-flex align-items-center justify-content-end asset-tag-ops-wrapper'>
                                                            {
                                                                actionsEnabled ?
                                                                    <React.Fragment>
                                                                        {
                                                                            isCompleted ?
                                                                                <span className='cursor-pointer mr-2' onClick={() => onHandleTagStatus(data, 'Reopened')}>
                                                                                    <OverlayTrigger placement="bottom"
                                                                                        overlay={
                                                                                            <Tooltip>Reopen </Tooltip>}>
                                                                                        <img src={ReloadIcon} className='cursor-pointer' alt="Edit" />
                                                                                    </OverlayTrigger>
                                                                                </span> :
                                                                                <span className='cursor-pointer mr-2' onClick={() => onHandleTagStatus(data, 'Completed')}>
                                                                                    <OverlayTrigger placement="bottom"
                                                                                        overlay={
                                                                                            <Tooltip>Complete </Tooltip>}>
                                                                                        <img src={CompletedIcon} className='cursor-pointer' alt="Edit" />
                                                                                    </OverlayTrigger>
                                                                                </span>
                                                                        }
                                                                        {
                                                                            data?.actionHistory ?
                                                                                <span className='cursor-pointer mr-2' onClick={() => handleTagHistory(data)}>
                                                                                    <OverlayTrigger placement="bottom"
                                                                                        overlay={
                                                                                            <Tooltip>History</Tooltip>}>
                                                                                        <Image src={HistoryIcon} className='cursor-pointer' alt="Edit" />
                                                                                    </OverlayTrigger>
                                                                                </span> : null
                                                                        }
                                                                    </React.Fragment> : null
                                                            }

                                                            <span className='cursor-pointer mr-2' onClick={() => onHandleTagStatus(data, "update")}>
                                                                <OverlayTrigger placement="bottom"
                                                                    overlay={
                                                                        <Tooltip>Edit</Tooltip>}>
                                                                    <img src={BorderEditIcon} className='cursor-pointer' alt="Edit" />
                                                                </OverlayTrigger>
                                                            </span>
                                                            <span className='cursor-pointer' onClick={() => onHandleTagStatus(data, "delete")}>
                                                                <OverlayTrigger placement="bottom"
                                                                    overlay={
                                                                        <Tooltip>Delete </Tooltip>}>
                                                                    <img className="cursor-pointer" src={DeleteIcon} alt="Delete Document" />
                                                                </OverlayTrigger>
                                                            </span>
                                                        </div>
                                                    </th> : null}
                                                </tr>
                                            </thead>
                                            {
                                                getTagRecords(data)
                                            }
                                        </Table>
                                    </Dropdown.Item>
                                     }): null }
                                </Dropdown.Menu>}
                            </Dropdown>
                        )
                            : null
                    }
                    )
                }
                <TagsHistoryPopup
                    showModal={tagHistoryPopupState.showModalPopup}
                    onClose={() => settagHistoryPopupState({
                        ...tagHistoryPopupState,
                        showModalPopup: false
                    })}
                    data={tagHistoryPopupState.data}
                    tagName={tagHistoryPopupState.tagName}
            />
        </> : null
    )
};

export default TagsInfo;